module.exports = __webpack_public_path__ + "static/nestle-horiz.46e5a28b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/nestle-horiz.svg
// module id = 106
// module chunks = 59819425949494 221427640695397